import * as _ from 'underscore';

import { themeId, themeFields, name as widgetName, moduleName } from '../config';

import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { validators as ValidatorPlatform } from '../../../../_common/platform/ts/validators';
import { validators } from '../../../../_common/platform/ts/validators';

import BooleanField from '../../../../_common/platform/ts/BooleanField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import { TitlePositionSelect } from '../../../../_common/platform/tsx/TitlePositionSelect';
import { getEditingModeSelectorOptions } from '../../../../_common/platform/tsx/dataEdit/OptionsTab';

const template = require('!!raw-loader!pdc-widget-data-edit/src/mainTheme.template.css').default;

template;

const _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeId,
            name: widgetName,
            parent: 'widget',

            themeType: widgetName,
            visibility: ['application', 'workspace', moduleName]
        }
    ]);

    appTheme.registerGroups([
        {
            id: themeFields.themeGroup_dataProcessing,
            name: 'Data Processing',
            section: themeId
        },
        {
            id: themeFields.themeGroup_style,
            name: 'Style',
            section: themeId
        },
        {
            id: themeFields.themeGroup_columnOptions,
            name: 'Column Options',
            section: themeId
        },
        {
            id: themeFields.themeGroup_gridOptions,
            name: 'Grid Options',
            section: themeId
        },
        {
            id: themeFields.themeGroup_gridSearchPanel,
            name: 'Search Panel',
            section: themeId
        },
        {
            id: themeFields.themeGroup_ToolbarButtons,
            name: 'Toolbar Buttons',
            section: themeId
        },
        {
            id: themeFields.themeGroup_storeGridLayout,
            name: 'Store Grid Layout Options',
            section: themeId
        },
        {
            id: themeFields.themeGroup_dialogOptions,
            name: 'Popup Dialog Options',
            section: themeId
        },
        {
            id: themeFields.themeGroup_FilterRow,
            name: 'Filter Row',
            section: themeId
        },
        {
            id: themeFields.themeGroup_WordWrap,
            name: 'Word Wrap',
            section: themeId
        }
    ]);

    appTheme.registerVars([
        {
            id: themeFields.endlessScrolling,
            param: new BooleanField(glob, 'Endless Scrolling', [], false),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.allowInserting,
            param: new BooleanField(glob, 'Allow Inserting', [], true),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.allowUpdating,
            param: new BooleanField(glob, 'Allow Updating', [], true),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.allowDeleting,
            param: new BooleanField(glob, 'Allow Deleting', [], true),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.transactionMode,
            param: new BooleanField(glob, 'Use Apply Button', [], false),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.multiRowOperations,
            param: new BooleanField(glob, 'Multi Row Operations', [], false),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },
        {
            id: themeFields.showHistory,
            param: new BooleanField(glob, 'Show History (when is supported by Entity)', [], true),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },

        {
            id: themeFields.editingMode,
            param: new SelectField(
                glob,
                'Editing Mode',
                [],
                function (theme) {
                    //18.08.2021: Inline Edit is obsolete. It is for compartibility.
                    if (theme[themeFields.editingMode] == null && theme['data-edit-inline-edit']) {
                        return 'cell';
                    } else {
                        return 'dialog';
                    }
                },
                getEditingModeSelectorOptions()
            ),
            section: themeId,
            group: themeFields.themeGroup_dataProcessing
        },

        // Dialog Options
        {
            id: themeFields.titlePosition,
            param: new TitlePositionSelect(glob),
            section: themeId,
            group: themeFields.themeGroup_dialogOptions
        },
        {
            id: themeFields.titleWidth,
            param: new NumberField(
                glob,
                'Width of Field Label',
                [validators.number.not_negative, validators.number.integer],
                null,
                {
                    allowNull: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_dialogOptions
        },
        {
            id: themeFields.verticalSpacing,
            param: new NumberField(
                glob,
                'Vertical Space Between Fields',
                [validators.number.integer, validators.number.range(0, 500)],
                null,
                {
                    allowNull: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_dialogOptions
        },
        {
            id: themeFields.styleBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Background Color',
                [],
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['widget-bg']
        },
        {
            id: themeFields.styleToolbarBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Toolbar Background Color',
                [],
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['widget-bg']
        },
        {
            id: themeFields.showColumnHeaders,
            param: new BooleanField(glob, 'Show Column Headers', [], true),
            section: themeId,
            group: themeFields.themeGroup_style
        },
        {
            id: themeFields.styleHeaderFontColor,
            param: new ColorBoxField(
                glob,
                'Header Font Color',
                [],
                function (theme) {
                    return theme['on-secondary']; //  gray-base
                },
                { hideTransparency: true }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['on-secondary'] // gray-base
        },
        {
            id: themeFields.styleHeaderBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Header Background Color',
                [],
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['widget-bg']
        },
        {
            id: themeFields.styleRowFontColor,
            param: new ColorBoxField(
                glob,
                'Row Font Color',
                [],
                function (theme) {
                    return theme['on-secondary']; // gray-base
                },
                { hideTransparency: true }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['on-secondary'] // gray-base
        },
        {
            id: themeFields.styleRowBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Row Background Color',
                [],
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['widget-bg']
        },
        {
            id: themeFields.styleGroupRowFontColor,
            param: new ColorBoxField(
                glob,
                'Group Row Font Color',
                [],
                function (theme) {
                    return theme['on-secondary']; // gray-base
                },
                { hideTransparency: true }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['on-secondary'] // gray-base
        },
        {
            id: themeFields.styleGroupRowBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Group Row Background Color',
                [],
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            group: themeFields.themeGroup_style,
            deps: ['widget-bg']
        },
        {
            id: themeFields.editableCellsBackgroundColor,
            param: new ColorBoxField(glob, 'Editable Cells Background Color', [], null, { hideTransparency: true }),
            section: themeId,
            group: themeFields.themeGroup_style
        },
        {
            id: themeFields.styleRowAlternation,
            param: new BooleanField(glob, 'Row Alternation', [], false), //LL: false is DevExpress default, Grid widget has "true"
            section: themeId,
            group: themeFields.themeGroup_style
        },
        {
            id: themeFields.showRowLines,
            param: new BooleanField(glob, 'Show Row Lines', [], true),
            section: themeId,
            group: themeFields.themeGroup_style
        },
        {
            id: themeFields.showColumnLines,
            param: new BooleanField(glob, 'Show Column Lines', [], true),
            section: themeId,
            group: themeFields.themeGroup_style
        },
        {
            id: themeFields.gridLinesColor,
            param: new ColorBoxField(glob, 'Vertical & Horizontal Line Color', [], '#DDDDDD', {
                hideTransparency: true
            }),
            section: themeId,
            group: themeFields.themeGroup_style
        },
        // {
        //     id: themeFields.style_header_alignment,
        //     param: new SelectField(glob, 'Column Header Alignment', [], 'default', {
        //         values: ['default', 'left', 'center', 'right'],
        //         display: ['default', 'left', 'center', 'right']
        //     }),
        //     section: themeId,
        //     group: themeFields.themeGroup_style
        // },

        // Column Options
        {
            id: themeFields.allowColumnFixing,
            param: new BooleanField(glob, 'Allow Column Fixing', [], true),
            section: themeId,
            group: themeFields.themeGroup_columnOptions
        },
        {
            id: themeFields.allowColumnResize,
            param: new BooleanField(glob, 'Allow Column Resizing', [], true),
            section: themeId,
            group: themeFields.themeGroup_columnOptions
        },
        {
            id: themeFields.columnResizingMode,
            param: new SelectField(glob, 'Column Resizing Mode', [], 'nextColumn', {
                values: ['nextColumn', 'widget'],
                display: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ],
                tooltips: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ]
            }),
            section: themeId,
            group: themeFields.themeGroup_columnOptions
        },
        {
            id: themeFields.columnMinWidth,
            param: new NumberField(
                glob,
                'Min Column Width (px)',
                [
                    ValidatorPlatform.number.range(0, 50),
                    ValidatorPlatform.number.not_negative,
                    ValidatorPlatform.number.integer
                ],
                null,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_columnOptions
        },

        // Grid Options
        {
            id: themeFields.allowGrouping,
            param: new BooleanField(glob, 'Allow Grouping', [], false),
            section: themeId,
            group: themeFields.themeGroup_gridOptions
        },
        {
            id: themeFields.hideNoDataMessage,
            param: new BooleanField(glob, 'Hide "No Data" message', [], false),
            section: themeId,
            group: themeFields.themeGroup_gridOptions
        },
        {
            id: themeFields.showToolbar,
            param: new BooleanField(glob, 'Show Grid Toolbar', [], true),
            section: themeId,
            group: themeFields.themeGroup_gridOptions
        },
        {
            id: themeFields.detailsComponentHeight,
            param: new NumberField(
                glob,
                'Details Height',
                [ValidatorPlatform.number.range(50, 1000), ValidatorPlatform.number.integer],
                300,
                {
                    applyOnEnter: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_gridOptions
        },

        {
            id: themeFields.allowFilterRow,
            param: new BooleanField(glob, 'User can toggle Filter Row', [], false),
            section: themeId,
            group: themeFields.themeGroup_FilterRow
        },
        {
            id: themeFields.filterRowEnabled,
            param: new BooleanField(glob, 'Filter Row is enabled by default', [], false),
            section: themeId,
            group: themeFields.themeGroup_FilterRow
        },

        {
            id: themeFields.allowWordWrap,
            param: new BooleanField(glob, 'User can change Word Wrap', [], false),
            section: themeId,
            group: themeFields.themeGroup_WordWrap
        },
        {
            id: themeFields.wordWrapEnabled,
            param: new BooleanField(glob, 'Word Wrap is enabled by default', [], false),
            section: themeId,
            group: themeFields.themeGroup_WordWrap
        },

        {
            id: themeFields.searchPanelShow,
            param: new BooleanField(glob, 'Show Search Panel', [], false),
            section: themeId,
            group: themeFields.themeGroup_gridSearchPanel
        },
        {
            id: themeFields.searchPanelWidth,
            param: new NumberField(
                glob,
                'Search Panel Width',
                [ValidatorPlatform.number.range(50, 300), ValidatorPlatform.number.integer],
                120,
                {
                    applyOnEnter: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_gridSearchPanel
        },

        {
            id: themeFields.columnChooserShow,
            param: new BooleanField(glob, 'Show Column Chooser Button in Grid Toolbar', [], false),
            section: themeId,
            group: themeFields.themeGroup_ToolbarButtons
        },
        {
            id: themeFields.resetLayoutButtonShow,
            param: new BooleanField(glob, 'Show Reset Layout Button in Grid Toolbar', [], false),
            section: themeId,
            group: themeFields.themeGroup_ToolbarButtons
        },

        {
            id: themeFields.storeGridLayout_resetLayoutAfterConfigurationChange,
            param: new BooleanField(glob, 'Reset Layout after Saving of Changed Configuration', [], true),
            section: themeId,
            group: themeFields.themeGroup_storeGridLayout
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-data-edit']);

    appTheme.registerPreRender(function (input) {
        const vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
